import { WorkflowInstanceStatus as GqlWorkflowInstanceStatus } from '@willow/graphql-iso/src/app';
import { assertNever, WorkflowStatus } from '@willow/types-iso';

export const gqlWorkflowInstanceStatusToWorkflowStatus = (gqlStatus: GqlWorkflowInstanceStatus): WorkflowStatus => {
  switch (gqlStatus) {
    case GqlWorkflowInstanceStatus.Active:
      return { status: 'active' };
    case GqlWorkflowInstanceStatus.Cancelled:
      return { status: 'cancelled' };
    case GqlWorkflowInstanceStatus.Completed:
      return { status: 'completed' };
    default:
      assertNever(gqlStatus);
  }
};

export const workflowStatusToGqlWorkflowInstanceStatus = (
  status: WorkflowStatus['status'],
): GqlWorkflowInstanceStatus => {
  switch (status) {
    case 'active':
      return GqlWorkflowInstanceStatus.Active;
    case 'cancelled':
      return GqlWorkflowInstanceStatus.Cancelled;
    case 'completed':
      return GqlWorkflowInstanceStatus.Completed;
    default:
      assertNever(status);
  }
};
